import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as TYPES from './types';
import { extractProductReference } from '~/helpers/extract-helper';
import { fetchProduct as _fetchProduct, fetchProductCarousels as _fetchProductCarousels } from '~/services/product';
export default {
  fetchProductCarousels: function fetchProductCarousels(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, alias, profileId, exclude, reference, product;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              alias = _ref2.alias, profileId = _ref2.profileId, exclude = _ref2.exclude;
              reference = extractProductReference(alias);
              _context.next = 5;
              return _fetchProductCarousels(_this, reference, profileId, exclude);

            case 5:
              product = _context.sent;
              commit(TYPES.SET_PRODUCT_CAROUSELS, product);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  fetchProduct: function fetchProduct(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, alias, query, profileId, reference, product, currentLocale, currentQuery, currentAlias, redirectUrl, redirectCode;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              alias = _ref4.alias, query = _ref4.query, profileId = _ref4.profileId;
              reference = extractProductReference(alias);
              _context2.next = 5;
              return _fetchProduct(_this2, reference, query.offer, profileId);

            case 5:
              product = _context2.sent;
              currentLocale = _this2.state.i18n.currentLocale;
              currentQuery = keys(query).length ? "?".concat(stringify(query)) : '';
              currentAlias = "".concat(product.slug, "-").concat(product.reference, ".htm");

              if (alias !== currentAlias && process.server) {
                _this2.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/p/").concat(currentAlias).concat(currentQuery));
              }

              redirectUrl = product && product.redirection && product.redirection.redirectUrl;

              if (redirectUrl && redirectUrl !== '#') {
                if (process.server) {
                  redirectCode = product.redirection.redirectHttpCode || 301;

                  _this2.app.context.redirect(redirectCode, "".concat(redirectUrl).concat(currentQuery));
                } else {
                  window.location.href = "".concat(redirectUrl).concat(currentQuery);
                }
              }

              commit(TYPES.SET_PRODUCT, product);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};